export default "__VITE_ASSET__CcDbrsP2__"